import React, {useEffect} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {Button, Dialog, DialogContent, DialogTitle, Stack, Typography,} from '@mui/material';
import {yupResolver} from '@hookform/resolvers/yup';
import {useGetRic, useUpdateRic, validationSchemaRic} from './Services';
import {Ric} from './types';
import * as Yup from "yup";
import {FormField} from '../../common/FormField';
import {useFieldsRic_1, useFieldsRic_2, useFieldsRic_3, useFieldsRic_4} from './FormRic';

interface EditRicProps {
  open: boolean;
  onClose: () => void;
  idricprop: number;
}

const EditRic: React.FC<EditRicProps> = ({ open, onClose,idricprop   }) => {

      type RicForm = Yup.InferType<typeof validationSchemaRic>


  const { control, handleSubmit, reset,watch,setValue } = useForm<RicForm>({
    resolver: yupResolver(validationSchemaRic),

  });


  const f1 = useFieldsRic_1();
  const f2 = useFieldsRic_2();
  const f3 = useFieldsRic_3();
  const f4 = useFieldsRic_4();

 const { data, isLoading } = useGetRic(idricprop);
  const { mutateAsync, isPending } = useUpdateRic();

useEffect(() => {
  if (!data) return;


  reset({
    ...data,
  });
}, [data, reset]);




  const onSubmit: SubmitHandler<RicForm> = async data => {
    // console.log("FINAL FORM DATA:", data);

    const payload = {
                  ...data,
                };

    await mutateAsync(payload as Ric);
    onClose();
  };

  const handleClose = () => {
    reset();
    onClose();
  };



  return (
    <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6">Edit Ric</Typography>
      </DialogTitle>
         <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack direction="row" spacing={1}>
            {f1.map(f => (
              <FormField key={String(f.name)} control={control} field={f as any} />
            ))}
          </Stack>

          <Stack direction="row" spacing={1}>
            {f2.map(f => (
              <FormField key={String(f.name)} control={control} field={f as any} />
            ))}
          </Stack>

          <Stack direction="row" spacing={1}>
            {f3.map(f => (
              <FormField key={String(f.name)} control={control} field={f as any} />
            ))}
          </Stack>

          <Stack direction="row" spacing={1}>
            {f4.map(f => (
              <FormField key={String(f.name)} control={control} field={f as any} />
            ))}
          </Stack>

          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button onClick={handleClose} color="error">
              Annulla
            </Button>
            <Button type="submit" variant="contained" disabled={isPending}>
              {isPending ? "Salvando…" : "Salva"}
            </Button>
          </Stack>
        </form>
      </DialogContent>



    </Dialog>

  </>

  );
};

export default EditRic;
